import { z } from "zod";

export const EtlRunStatus = {
	RUNNING: "running",
	COMPLETED: "completed",
} as const;

export type EtlRunStatus = (typeof EtlRunStatus)[keyof typeof EtlRunStatus];

export const ETL_RUN_STATUSES = Object.values(EtlRunStatus) as readonly EtlRunStatus[];

export const etlRunStatusSchema = z.enum(EtlRunStatus);
